<template>
    <div class="t-lk-modal__content">
        <h2 v-if="props.title" class="t-lk-modal__title">{{ props.title }}</h2>
        <h2 v-else class="t-lk-modal__title">{{ $root.staticText.lk.requestTitle }}</h2>

        <form-dynamic-cmp
            class="t-lk-modal__form t-lk-comp__training"
            :form-info="form"
            :button="props.button"
            :class-white="false"
        >
        </form-dynamic-cmp>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import formDynamic from '@components/base/form-dynamic.vue';

    export default {
        name: "request",
        props: ['props'],
        data() {
            return {
                infoForm: {
                    action: "lk/request",
                    disabledForm: false,
                    isPersonalData: false,
                    errorPersonalData: false,
                    success: false,
                    error: false,
                },
                form: {
                    "fields": [
                        {
                            "type": "form_field",
                            "content": {
                                "id": "name",
                                "title": this.$root.staticText.forms.fullName,
                                "typeField": 1,
                                "requiredField": 1,
                                "description": null,
                                disabled: true,
                                "hintField": this.$root.staticText.forms.placeholderFullName
                            }
                        },
                        {
                            "type": "form_field",
                            "content": {
                                "id": "company",
                                "title": this.$root.staticText.forms.company3,
                                "typeField": 1,
                                "requiredField": 1,
                                "description": null,
                                disabled: true,
                                "hintField": this.$root.staticText.forms.placeholderCompany
                            }
                        },
                        {
                            "type": "form_field",
                            "content": {
                                "id": "city",
                                "title": this.$root.staticText.forms.city,
                                "typeField": 1,
                                "requiredField": 1,
                                "description": null,
                                disabled: true,
                                "hintField": this.$root.staticText.forms.placeholderCity
                            }
                        },
                        {
                            "type": "form_field",
                            "content": {
                                "id": "email",
                                "title": this.$root.staticText.forms.email,
                                "typeField": 4,
                                "requiredField": 1,
                                "description": null,
                                "hintField": this.$root.staticText.forms.placeholderEmail
                            }
                        },
                        {
                            "type": "form_field",
                            "content": {
                                "id": "phone",
                                "title": this.$root.staticText.forms.phone,
                                "typeField": 11,
                                "requiredField": 1,
                                "description": null,
                                "hintField": null
                            }
                        },
                        {
                            "type": "form_field",
                            "content": {
                                "id": "vendor",
                                "title": this.$root.staticText.lk.compTrainingVendor,
                                "typeField": 8,
                                "requiredField": 1,
                                "description": null,
                                disabled: true,
                                "hintField": this.$root.staticText.forms.placeholderTypeRequest2,
                                "list": this.props.options,
                            }
                        },
                        {
                            "type": "form_field",
                            "content": {
                                "id": "comment",
                                "title": this.$root.staticText.forms.comment2,
                                "typeField": 2,
                                "requiredField": 0,
                                "description": null,
                                "hintField": null,
                            }
                        },
                    ]
                }
            }
        },
        watch: {
            'infoForm.success': function() {
                if (this.infoForm.success) {
                    this.modalClose();
                    this.modalType_successOpen({
                        title: this.$root.staticText.modal.successTitleFeedback,
                        text: this.$root.staticText.modal.successTextFeedback,
                        class: '_small'
                    });
                }

            },
            'infoForm.error': function() {
                if (this.infoForm.error) {
                    this.modalClose();
                    this.modalType_errorOpen({
                        title: this.$root.staticText.modal.errorTitle,
                        text: this.$root.staticText.modal.errorText,
                        class: '_small'
                    });
                }
            }
        },
        components: {
            'form-dynamic-cmp': formDynamic,
        },
        computed: {
            ...mapGetters('lk', ['profile']),
        },
        methods: {
            ...mapActions('modal', ['modalType_successOpen', 'modalType_errorOpen', 'modalClose']),
        },
        created() {
            this.form.fields.forEach(item => {
                switch (item.content.id) {
                    case 'name':
                        item.content.value = (this.profile && (this.profile.name || this.profile.surname)) ?
                            this.profile.name + ' ' + this.profile.surname : null;
                        break;
                    case 'company':
                        item.content.value = (this.profile && this.profile.company) ? this.profile.company : null;
                        break;
                    case 'email':
                        item.content.value = (this.profile && this.profile.email) ? this.profile.email : null;
                        break;
                    case 'phone':
                        item.content.value = (this.profile && this.profile.phone) ? this.profile.phone : null;
                        break;
                    case 'city':
                        item.content.value = (this.profile && this.profile.city) ? this.profile.city : null;
                        break;
                    case 'vendor':
                        item.content.value = [{
                            id: this.props.vendorId,
                            label: this.props.vendor
                        }];
                        break;
                }
            });
        }
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/components/base/modals/training.vue